<h5>Prescriber Tasks</h5>
@if (!loadingRelatedTasks) {
  @if (relatedTasks.length > 0) {
    <div>
      <p>All prescriber tasks for patient, {{ task.patient.fullName }} DOB {{ task.patient.dob | date: 'MM/dd/yyyy' }}.
      </p>
      <table class="table table-sm">
        <thead>
          <tr>
            <th class="text-center">TASK ID</th>
            <th>STATUS</th>
            <th>PRESCRIBER</th>
            <th class="text-center">ESTIMATED VALUE</th>
            <th class="text-center">EXPIRES ON</th>
          </tr>
        </thead>
        <tbody>
          @for (relatedTask of relatedTasks; track relatedTask) {
            <tr>
              <td class="text-center">
                <a target="_blank" routerLinkActive="active" routerLink="/ce-portal/tasks/client-prescriber-tasks/{{ relatedTask.id }}">{{ relatedTask.id }}</a>
              </td>
              <td>{{ relatedTask.status | taskStatus }}</td>
              <td><app-prescriber-name [provider]="relatedTask.provider" [showSpecialtiesDetails]="true" /></td>
              <td class="text-center"><app-task-estimated-value [rank]="relatedTask.estimatedValueRank" [value]="relatedTask.estimatedValue" /></td>
              <td class="text-center"><app-expiration-date [expirationDate]="relatedTask.nextClaimExpirationDate" /></td>
            </tr>
          }
        </tbody>
      </table>
      @if (showSeeAll) {
        <div class="text-center">
          <a href="#" (click)="clickSeeAll($event)">All Other</a>
        </div>
      }
    </div>
  } @else {
    <p>There are no related tasks.</p>
  }
} @else {
  <mat-spinner [diameter]="30" />
}
